import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters(['userRole', 'appSavitarna']),
    roleEL() {
      return this.roleOr(['EL_JA', 'EL_FA'])
    },
    roleNone() {
      return this.userRole.length === 0
    },
  },
  methods: {
    role(checkRole) {
      let roleList = Array.isArray(checkRole) ? checkRole : [checkRole]
      return roleList.every((item) => {
        return this.userRole.includes(item)
      })
    },
    roleOr(checkRole) {
      let roleList = Array.isArray(checkRole) ? checkRole : [checkRole]
      return roleList.some((item) => {
        return this.userRole.includes(item)
      })
    },
  },
}
